

import { EventManager } from './EventManager.js';
import Vue from 'vue'

import fuse from 'fuse.js/dist/fuse.js';
import axios from 'axios';
import VueRouter from 'vue-router';

import LazyImage from './LazyImage.vue';
import LazyBackgroundImage from './LazyBackgroundImage.vue';

export default {
    data() {
        return {
          fuse: null,
          router: null,
          isBusy: false,
          sortBy: 'last-name',

          defaultPostId: -1,
          selectedPostId: -1,

          defaultPage: -1,
          page: 1,
          maxPages: 1,
          isMorePages: false,
          isChangingPages: false,
          query: '',
        };
    },

    props: {
      dataSource: {
        type: String,
        default: '',
      },
      placeholderProfileImage: {
        type: String,
        default: '',
      },
      groupLeadersOnTop: {
        type: Boolean,
        default: false,
      },
      posts: {
        type: Array,
        default: function() {
          return [];
        },
      },
      breadcrumbs: {
        type: Array,
        default: function() {
          return [];
        },
      },
      backLink: {
        type: String,
        default: '',
      },
      tab: {
        type: String,
        default: '',
      },
      backLinkLabel: {
        type: String,
        default: 'Back',
      },
      postsPerPage: {
        type: Number,
        default: 20,
      },
    },

    computed: {
      results: function() {
        return this.query.length ? this.fuse.search(this.query) : this.posts;
      },
      params: function(){
        var params = {};

        if(this.sortBy) {
          params.sort = this.sortBy;
        }

        if(this.query.length) {
          params.search = this.query;
        }

        if(this.tab) {
          params.tab = this.tab;
        }

        if(this.page > 1) {
          params.page = this.page;
        }

        return params;
      },
      totalPages: function() {
        return Math.ceil(this.postsFiltered.length / this.postsPerPage);
      },
      paginationRange: function() {
        var range = []; //[this.page];

        var startPage = (Math.floor(this.page/5)*5);

        if(startPage <= 0) startPage = 1;

        if(startPage === this.totalPages && this.totalPages > 5) {
          startPage -= 5;
        }

        for (let n = startPage; n < startPage+5; n++) {
          if(n > this.totalPages) break;
          range.push(n);
        }

        if(range[range.length-1] < (this.totalPages - 5)) {
          range.push('...');
        }

        if(range[range.length-1] !== this.totalPages) {
          range.push(this.totalPages);
        }

        return range;
      },
      indexRange: function() {
        var maxIndex = this.postsPerPage * this.page,
            minIndex = maxIndex - this.postsPerPage;
        return {min: minIndex, max: maxIndex};
      },
      postsVisible: function() {
        var postsMutable = this.postsFiltered;
        return (postsMutable.length > this.indexRange.min) ? postsMutable.slice(this.indexRange.min, this.indexRange.max) : postsMutable;
      },
      postsFiltered: function() {
        var self = this,
            postsFiltered = [],
            posts = self.results;

            self.updateRoutes(); // updating URL

            for (let i = 0; i < posts.length; i++) {

              var post = (typeof posts[i].item === 'undefined') ? posts[i] : posts[i].item,
                  includePost = true;

                  // if(self.sortBy === 'group' && !post.group || !post.group.length) {
                  //   includePost = false;
                  // }

//               if(self.selectedThemeSlugs.length || self.selectedAgeGroupSlugs.length || self.selectedMonthIds.length) {
//                 includePost = false;
//
//                 if(self.selectedAgeGroups.length) {
//                   for (let i = 0; i < self.selectedAgeGroups.length; i++) {
//                     var ageGroup = self.selectedAgeGroups[i];
//
//                     if(post.age_groups.includes(ageGroup.slug)) {
//                       includePost = true;
//                       break;
//                     }
//                   }
//                 }
//
//               }

              if(includePost) {
                postsFiltered.push(post);
              }
            }

            // Sorting by name first
            var postsSorted = postsFiltered.sort(function(post1, post2){
                var lname1 = (post1.last_name) ? post1.last_name : '',
                    lname2 = (post2.last_name) ? post2.last_name : '';
                return lname1.localeCompare(lname2);
              });

        return postsSorted.sort(function(post1, post2){

          if(self.groupLeadersOnTop && post1.job_title.toLowerCase() === 'group leader') {
            return -1;
          }

          switch (self.sortBy) {
            case 'last-name':
            var lname1 = (post1.last_name) ? post1.last_name : '',
                lname2 = (post2.last_name) ? post2.last_name : '';
              return lname1.localeCompare(lname2);

            case 'first-name':
            var fname1 = (post1.first_name) ? post1.first_name : '',
                fname2 = (post2.first_name) ? post2.first_name : '';
              return fname1.localeCompare(fname2);

            case 'group':
              var group1 = (post1.group) ? post1.group : '',
                  group2 = (post2.group) ? post2.group : '';

              return (!group2.length && group1.length) ? 1 : group1.localeCompare(group2);
          }

          return post1.title.localeCompare(post2.title);
        });
      },
    },

    watch: {
      // posts: function (newValue, oldValue) {
      //   this.reloadFeatureMonths();
      //   this.initFuse();
      // },
    },

    methods: {
      clearFilters: function() {
        this.query = '';
        this.sortBy = [];
      },
      initFuse: function() {
        this.fuse = new fuse(this.posts, {
            minMatchCharLength: 2,
            keys: ['title', 'group'],
            threshold: 0.2,
        });
      },
      padNumber: function(num, size = 2) {
        var s = '000000000' + num;
        return s.substr(s.length-size);
      },
      loadPreviousPage: function () {
        this.page--;
      },
      goToPage: function (pageNumber) {
        if(isNaN(pageNumber)) return;
        this.page = pageNumber;
      },
      loadNextPage: function () {
        if(this.page < this.totalPages) {
          this.page++;
        }
      },
      loadLastPage: function () {
        this.page = this.totalPages;
      },
      postWithId: function(postId) {
          for (let i = 0; i < this.postsFiltered.length; i++) {
            if (this.postsFiltered[i].id === postId) {
              return this.postsFiltered[i];
            }
          }
          return null;
      },
      didSelectPost: function(post) {
        this.selectedPostId = post.id;
      },
      updateRoutes: function() {
        if(this.router != null) {
          this.router.push({ path: window.location.pathname, query: this.params}).catch(err => {  }); // eslint-disable-line
        }
      },
    },

    components: {
      LazyBackgroundImage,
      LazyImage,
    },

    created() {
      //
    },

    destroyed () {

    },

    mounted() {
      var self = this,
          urlParams = new URLSearchParams(window.location.search);

      if(urlParams.get('page') && urlParams.get('page').page) {
        self.defaultPage = parseInt(urlParams.get('page'));
      }

      if(urlParams.get('sort') && urlParams.get('sort').length) {
        self.sortBy = urlParams.get('sort');
      }

      if(urlParams.get('search')) {
        self.query = urlParams.get('search');
      }

      self.initFuse();
      self.router  = new VueRouter({mode: 'history'});

    },

};




// WEBPACK FOOTER //
// ./scripts/vue/PeoplePicker.vue